import React, { FC } from 'react';
import { Field, Spacer } from '@chakra-ui/react';
const ChakraFormLabel = Field.Label;
import { FormLabelProps } from './types';
import { InfoButton } from '../InfoButton';
import { Layout } from '../Layout';

export const FormLabel: FC<FormLabelProps> = ({
  label,
  children,
  id,
  htmlFor,
  tooltip,
  asLegend = false,
  className,
  'aria-hidden': ariaHidden,
}) => {
  const chakraLabel = (
    <ChakraFormLabel
      as={asLegend ? 'legend' : 'label'}
      id={id}
      htmlFor={asLegend ? '' : (htmlFor ?? id)}
      className={className}
      aria-hidden={ariaHidden}
    >
      {children ?? label}
      {/* Reads the ambient (non-strict) Field context itself; no-ops with no Field.Root ancestor. */}
      <Field.RequiredIndicator />
    </ChakraFormLabel>
  );

  // Only wrap in Layout when a tooltip button is needed — otherwise render the label
  // element directly so CSS rules like `label + input` continue to work (e.g. floating labels).
  if (!tooltip) {
    return chakraLabel;
  }

  return (
    <Layout variant="flex" alignItems="center">
      {chakraLabel}
      <Spacer />
      <InfoButton tooltip={{ placement: 'top' as any, ...tooltip }} me="-1" />
    </Layout>
  );
};

FormLabel.displayName = 'FormLabel';
